import { render, staticRenderFns } from "./DateList.vue?vue&type=template&id=b4a4a57e&"
import script from "./DateList.vue?vue&type=script&lang=js&"
export * from "./DateList.vue?vue&type=script&lang=js&"
import style0 from "./DateList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports